export default [
  {
    path: '/housekeeper-commerce',
    component: '@/pages/externalPages/HousekeeperCommerce',
    title: '邻居商品',
    meta: {
      analytic: 'housekeeper_commerce',
    },
  },
  {
    path: '/choose-project',
    component: '@/pages/externalPages/ChooseProject',
    title: '邻居商品',
  },
  {
    path: '/my-recommendation',
    component: '@/pages/externalPages/MyRecommendation',
    title: '我的推荐',
  },
  {
    // 对接管家学院，展示友邻商品详情
    path: '/external-product-detail',
    component: '@/pages/externalPages/ExternalProductDetail',
    title: '友邻商品详情',
  },
  {
    // 自研版，展示友邻商品详情
    path: '/blackpearl-product-detail',
    component: '@/pages/externalPages/BlackpearlProductDetail',
    title: '友邻商品详情',
    meta: {
      analytic: 'blackpearl_product_detail',
    },
  },

  {
    // 自研版，展示便民商品详情
    path: '/neighbor-product-detail',
    component: '@/pages/externalPages/NeighborProductDetail',
    title: '便民商品详情',
    meta: {
      analytic: 'neighbor_product_detail',
    },
  },
  {
    // 光明商品中转页面
    path: '/goods-external',
    component: '@/pages/externalPages/goodsExternal',
    title: ' ',
  },
  {
    // 住这儿首页 市集tab
    path: '/zzr-market-tab',
    component: '@/pages/zzrMarketTab',
    title: '市集',
  },
  {
    // 住这儿首页 好服务tab
    path: '/zzr-good-service-tab',
    component: '@/pages/zzrGoodServiceTab',
    title: '好服务',
    meta: {
      analytic: 'zzr_good_service_tab',
    },
  },
];
